import { ThunkDispatch } from '@reduxjs/toolkit';
import { AnyAction, Middleware } from 'redux';

import { AppState } from '@modules';

import { GlobalTypes } from './global';

export type TThunkDispatch = ThunkDispatch<AppState, null, AnyAction>;
export type TMiddleware = Middleware<unknown, AppState, TThunkDispatch>;

export type ApiRate = {
  rate: string;
  consent_required?: 'zh' | 'us';
  rate_with_fee: string;
} & {
  [key in 'total' | 'subtotal' | 'fee']: {
    [k in GlobalTypes.CurrencyEnum]?: string;
  };
};

export enum OperationNextEnum {
  pin = 'pin',
  customerIdentity = 'customer_identity',
  otp = 'otp',
  verifyDescriptor = 'verify-descriptor',
  zhAgree = 'zh-agree',
}

export enum VerifyNextEnum {
  verifyDescriptor = 'verify-descriptor',
  verifyOldEmail = 'verify-old-email',
  sendEmail = 'send-email',
  sendOldEmail = 'send-old-email',
  sendNewEmail = 'send-new-email',
  verifyEmail = 'verify-email',
  verifyPhone = 'verify-phone',
  verifyPassword = 'verify-password',
  setCountry = 'set-country',
  setPassword = 'set-password',
}

export enum ProtectNextEnum {
  setupOTP = 'setup-otp',
  verifyOTP = 'verify-otp',
}

export enum AuthFlowEnum {
  email = 'email',
}

export const LOCATION_CHANGE_TYPE = '@@router/LOCATION_CHANGE';
